module.exports = __webpack_public_path__ + "static/media/safe.51fe92b9.svg";